import { Component } from '@angular/core';
import {SpinnerComponent} from "src/app/common/spinner/spinner.component";
import qs from 'qs';
import {ActivatedRoute, Router} from "@angular/router";
import {OauthResponse} from "src/app/interfaces/oauth-response";
import {AuthService} from "src/app/services/Auth/auth.service";

@Component({
  selector: 'app-oauth',
  imports: [
    SpinnerComponent
  ],
  templateUrl: './oauth.component.html',
  styleUrl: './oauth.component.scss'
})
export class OauthComponent {
  token: string = '';
  constructor(private ac: ActivatedRoute,
              private auth: AuthService,
              private router: Router) {


  }
  ngOnInit(){
    const response: OauthResponse = new Object(qs.parse(this.ac.snapshot.fragment??'')) as OauthResponse;
    this.apiValidateOauthToken(response);
  }
  apiValidateOauthToken(res: OauthResponse){
    this.auth.googleLogin(res.access_token)
        .subscribe({
          error: err => localStorage.setItem('oauth_error', err.error.message)
        })
      .add(() => window.close())
  }
}
